import type { FaireProductEntity } from "../../entity_types/product";

export const p_r5y6c9f9c5: FaireProductEntity = {
  token: "p_r5y6c9f9c5",
  type: "product",
  name: "Pacific\u2122 Stackable Crystal Tiki Cocktail Glasses Set of 2",
  brandName: "Viski",
  imageUrl:
    "https://cdn.faire.com/fastly/fd0de1243dbb5327c9cc29ed3a667d53ad1aad01492d14595ac86282d97429eb.jpeg",
  priceDollars: 21.99,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/5cbb7fd458884e873215c616d0f0102be6dcc785e2fb6d85bf2c9c4edd8cf65a.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
